import { RadioButtonSection, RadioButtonSectionGroup } from '@components'

import { Spacing } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useLegalMentionsModalForm } from '../../../../../../../../context/legalMentionsModalFormContext'
import { EarlyPaymentDiscountCustomMentionField } from './elements/EarlyPaymentDiscountCustomMentionField'
import { EarlyPaymentDiscountCustomMentionType } from './enums/earlyPaymentDiscountCustomMentionType'

export const EarlyPaymentDiscountMentionsGroup = (): ReactElement => {
  const { t } = useTranslation()
  const { legalMentionsModalForm } = useLegalMentionsModalForm()
  const { control, setValue } = legalMentionsModalForm

  const customMention = useWatch({
    control,
    name: 'custom.earlyPaymentDiscount',
  })

  const selectedMentionType =
    customMention === null
      ? EarlyPaymentDiscountCustomMentionType.Default
      : EarlyPaymentDiscountCustomMentionType.Custom

  const handleRadioChange = useCallback(
    (value?: EarlyPaymentDiscountCustomMentionType) => {
      if (value === EarlyPaymentDiscountCustomMentionType.Default && customMention !== null) {
        setValue('custom.earlyPaymentDiscount', null, { shouldDirty: true })
      } else if (value === EarlyPaymentDiscountCustomMentionType.Custom && customMention === null) {
        setValue('custom.earlyPaymentDiscount', '', { shouldDirty: true })
      }
    },
    [customMention, setValue],
  )

  return (
    <>
      <RadioButtonSectionGroup direction="column" spacing={Spacing.S16} value={selectedMentionType}>
        <RadioButtonSection<EarlyPaymentDiscountCustomMentionType>
          description={t(
            `settings.organization.external_invoice.legal_mentions.modal.early_payment_discount.default_mention.description`,
          )}
          label={t(
            `settings.organization.external_invoice.legal_mentions.modal.early_payment_discount.default_mention.title`,
          )}
          labelVariant="bodyLG"
          onChange={handleRadioChange}
          value={EarlyPaymentDiscountCustomMentionType.Default}
        />
        <RadioButtonSection<EarlyPaymentDiscountCustomMentionType>
          label={t(
            `settings.organization.external_invoice.legal_mentions.modal.early_payment_discount.custom_mention.title`,
          )}
          labelVariant="bodyLG"
          onChange={handleRadioChange}
          value={EarlyPaymentDiscountCustomMentionType.Custom}
        />
      </RadioButtonSectionGroup>
      {selectedMentionType === EarlyPaymentDiscountCustomMentionType.Custom && (
        <EarlyPaymentDiscountCustomMentionField />
      )}
    </>
  )
}
